(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5610],{

/***/ 79511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[id]",
      function () {
        return __webpack_require__(18363);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BlogPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24277);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27101);
/* harmony import */ var _components_BlogPage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28692);









var __N_SSP = true;
function BlogPage(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, banners = _store.banners, article = _store.article, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var pageRoute = [
        {
            title: "Блог",
            link: "/blog"
        },
        {
            title: article.title,
            link: ""
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_7__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            user: user,
            article: article
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                user: user,
                article: article
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: "".concat(String(article === null || article === void 0 ? void 0 : article.seo_title), " | Блог Круиз.онлайн"),
                    description: String(article === null || article === void 0 ? void 0 : article.seo_description),
                    // openGraphTitle={String(article?.seo_title)}
                    openGraph: {
                        // url: 'https://www.url.ie/a',
                        title: String(article === null || article === void 0 ? void 0 : article.seo_title),
                        description: String(article === null || article === void 0 ? void 0 : article.seo_description),
                        siteName: "Круиз Онлайн"
                    },
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isAdvertising: true,
                    isMobile: isMobile,
                    isTablet: isTablet,
                    isContact: true,
                    isBlog: true,
                    popularPopdirs: popularPopdirs,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container--block",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_6__/* .BreadCrumbs */ .b, {
                                    routeCrumbs: pageRoute
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPage__WEBPACK_IMPORTED_MODULE_8__/* .BlogPostPage */ .o, {
                                isMobile: isMobile,
                                isTablet: isTablet,
                                banners: banners
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1272,718,7499,9264,9774,2888,179], function() { return __webpack_exec__(79511); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);